<header class="masthead" style="position: fixed;">
	<div class="navbar">
		<div class="left-header-subscribe">
				<button id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon" (click)="switchToWorkspace()">
					<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<title>Back</title>
							<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
											<g id="Back" transform="translate(40.000000, 28.000000)">
													<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
													<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
															<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
															<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
													</g>
											</g>
									</g>
							</g>
					</svg>
				</a>
					<span class="drop-down-option-workspace">
						Back to workspace
					</span>
				</button>
		</div>

		<div class="right-header">
			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
          <img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
						</div>
						<div class="hr-line"></div>
						<ul class="dropdown-list list-group">
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" >
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</header>

<section class="price-power-section"  *ngIf="mainSection">
<div class="container">
<div class="panel-wrapper">
<div class="left-panel">
  <div class="box-wrapper mb-4">
    <div class="d-flex">
      <div class="img-wrpper">
        <img src="assets/img/payment.png">
      </div>
      <div class="content-wrapper">
        <h3 class="mb-0 pb-0">Ready for Crafttor {{selectedMembership.title}}?</h3>
        <p class="upgrade-txt">Upgrade your plan and get:</p>
        <ul>
          <li><strong>Unlimited</strong> user billed at ${{selectedMembership.price_yearly*12}}/user/year</li>
					<li *ngIf="selectedMembership.allowed_workspace_count == 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspace</li>
						<li *ngIf="selectedMembership.allowed_workspace_count > 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspaces</li>
					<li *ngIf="selectedMembership.allowed_admin_count == 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admin</li>
					<li *ngIf="selectedMembership.allowed_admin_count > 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admins</li>
          <li><strong>Unlimited</strong> boards</li>
          <li *ngIf="selectedMembership.title == 'Plus'"><strong>{{selectedMembership.space/1000}} GB</strong> of storage.</li>
					<li *ngIf="selectedMembership.title == 'Professional'"><strong>{{selectedMembership.space/1000000}} TB</strong> of storage.</li>
					<li><strong>{{addUserCount}}</strong> seats(including owner).</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="right-panel">
  <div class="box-wrapper">
    <div class="plane-summary">
      <h3>Plan summary</h3>
      <table>
        <tbody>
              <tr>
                <td>
                  <input type="radio" name="subscription" value="yearly" id="yearly" [checked]="radioYearly">
                  <label for="yearly">Yearly<div class="badge">Save 20%</div></label>
                </td>
                <td>
                  <div class="price">${{selectedMembership.price_yearly*1}}/month</div>
                </td>
              </tr>
            <tr>
              <td colspan="2" class="coupon-box">
              <div class="collapse multi-collapse" id="multiCollapseExample1">
                <div class="input-group">
                <input type="text" class="form-control coupon" name="" placeholder="Coupon code">
                  <span class="input-group-append">
                    <button class="btn btn-primary btn-apply coupon">Apply</button>
                  </span>
                </div>
              </div>
              </td>
            </tr>
          <tr class="user">
            <td><p>{{addUserCount}} user on annual plan</p></td>
            <td>
              <p class="small"><b>${{totalPriceFixed}}</b></p>
            </td>
          </tr>

          <tr class="total">
            <td><p>Total</p></td>
            <td>
              <div class="price"><h4>${{totalPriceFixed}}</h4></div>
            </td>
          </tr>
          <tr class="button-wrapper">
						<td colspan="2">
							<!-- Stripe Code -->
               <a class="button" href="javascript:;" (click)="checkoutStripe(selectedMembership.price_yearly*12, 'usd', selectedMembership)">Upgrade</a>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <p class="small" style="font-size: 12px;">By confirming your subscription, you allow Crafttor to charge your card for this payment in accordance with their terms.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
</section>

  <section class="payment-success-section" *ngIf="paymentSuccessSection">
  	<div class="container">
  		<div class="row">
  			<div class="img-container">
  				<img src="assets/img/confirmed.svg">
  				<h1>${{totalPriceFixed}}/-</h1>
  				<h5>Your Payment is Successful!</h5>
  				<p>An invoice is sent to your email.</p>
  				<a href="javascript:;" class="button" (click)="switchToWorkspace()">Go to Workspace</a>
  			</div>

  		</div>
  	</div>
  </section>

  <div
  	style="width: 100%;
  	background-color: rgba(0,0,0, .9);
    padding-top:200px;"
    class="modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{'display':paymentProcessStyle}">
  	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
      width: 35%; margin: 0 auto; text-align: center;">
  		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
  			<div class="modal-body">
  				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
  			  <h6>Please wait</h6>
  			  <p>payment processing in progress..</p>
  			</div>
  		</div>
  	</div>
  </div>
